// extracted by mini-css-extract-plugin
module.exports = {"initials":"Initials_initials__1iAsV","letters":"Initials_letters__2pwmE"};